import React, {useRef, useState} from 'react';
import { Box } from '@mui/material';
import { CreateZonePlane, UploadImgZonePlane } from '../../../../reduxToolkit/EmployeeZones/EmployeeZonesApi';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import CustomModal from "../../../../components/Modal/CustomModal";
import {FILE_TYPE} from "../../../../Helpers/fileType";
import {CustomTextField} from "../../../../components/CustomTextField";
import DivContainerBody from "../../../../components/DivContainerBody";
import {getPhotoPicker, PHOTO_PICKER_MODEL} from '../../../../components/PhotoPicker/SubComponent/Models/Models';
import {ACTION_MODEL} from '../../../../Helpers/ActionModel';
import CustomPhotoPicker from '../../../../components/PhotoPicker/CustomPhotoPicker';
import noLogo from '../../../../assets/defaultImages/no-logo.png';

const ShowDeviceModal = (props) => {
    const { t } = useTranslation();
    const [imagePreviewUrl, setimagePreviewUrl] = useState([]);
    const [photoPicker, setPhotoPicker] = useState({ ...PHOTO_PICKER_MODEL,  preview: noLogo });
    const [selectedImage, setSelectedImage] = useState(null);
    const [name, setName] = useState('');
    const [submitClicked, setSubmitClicked] = useState(false);
    const [emptyFields, setEmptyFields] = useState(false);
    const fileInputRef = useRef(null);
    const dispatch = useDispatch();

    const resetForm = () => {
        setimagePreviewUrl([]);
        setPhotoPicker({...PHOTO_PICKER_MODEL,  preview: noLogo});
        setName('');
    };

    const addFilesToDropzone = (files, dropzone) => {
        let files_with_preview = [];
        files.map((file) => {
            file['preview'] = URL.createObjectURL(file);
            files_with_preview.push(file);
        });
        setimagePreviewUrl(files_with_preview['preview']);
        setSelectedImage([...files_with_preview]);
    };

    const createZoneplaneHandler = () => {

        if (name === '') {
            setEmptyFields(true)
            return
        }

        setEmptyFields(false)

        let imgPhotoPicker = getPhotoPicker(photoPicker);
        const createData = {
            name,
            zone: {
                id: JSON.parse(sessionStorage?.getItem('zonesStack'))[
                    JSON.parse(sessionStorage?.getItem('zonesStack')).length - 1
                ].id,
            },
            file: imgPhotoPicker,
            option: 'zone+',
        };

        if (!name) {
            setSubmitClicked(true);
        } else {
            if (!imgPhotoPicker) {
                toast.warn('Please attach image');
            } else {
                dispatch(CreateZonePlane(createData));
                resetForm();
                setSubmitClicked(false);
                props.onHide();
            }
        }
    };

    const handleClearSelfie = () => {
        setPhotoPicker({...PHOTO_PICKER_MODEL,  preview: noLogo});
        setSelectedImage(null);
        handleClearFileInput();
    };
    const handleClearFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };
    return (

            <CustomModal
                size='lg'
                buttonConfirm='add'
                {...props}
                title={'add'}
                onConfirm={() => {
                    createZoneplaneHandler();
                }}
                onClose={() => {
                    props.onHide();
                    props?.setProfileImage('');
                    setSubmitClicked(false);
                    setSelectedImage(null);
                    setPhotoPicker({...PHOTO_PICKER_MODEL});
                }}
            >
                <DivContainerBody>
                    <div className={"row mt-2"}>
                        <Box className='col-sm-12 col-md-12 col-xxl-12 col-lg-12 '>
                            <CustomTextField id={"txt_sdadd_name"}
                                             name={"name"}
                                             value={name}
                                             trans={"name"}
                                             onChange={(e) => setName(e.target.value)}
                                             required={true}
                                             emptyFields={emptyFields}
                            />
                        </Box>
                        <div className='d-flex justify-content-center align-items-center flex-column'>
                            <h3 className='ibl-h3-subtitle-grey'>{t('upload_from_file')}</h3>
                            <CustomPhotoPicker
                                id='fu_stk_file'
                                photoPicker={photoPicker}
                                setPhotoPicker={setPhotoPicker}
                                actionModel={ACTION_MODEL.CREATE}
                                accept={{ ...FILE_TYPE.IMAGE }}
                                classWith={'w-400px'}
                                titleInput={'choose_or_drag_your_image_here'}
                            />
                        </div>
                    </div>

                </DivContainerBody>
            </CustomModal>
    );
};

export default ShowDeviceModal;
